// src/constants.js

// ❗ Requiere que REACT_APP_ASSISTANT_URL esté definida en build time (CRA)
//const BASE = process.env.REACT_APP_ASSISTANT_URL;   MODIFICADO

// ACTUALIZAR ESTO ANTES DE HACER EL DEPLOY EN PRODUCCION
const BASE = "https://agente-demo.botvirtualia.com/"; //CAMBIAR LA URL AL DE PRODUCCION
//---------------------------------------------------------------------------------------

if (!BASE) {
  throw new Error('❌ ERROR: REACT_APP_ASSISTANT_URL no está definida. Añádela a tu .env antes de compilar.');
}

// Normaliza (sin trailing slash)
export const ASSISTANT_URL = String(BASE).replace(/\/+$/, '');

// 🔹 Auth endpoints
export const ASSISTANT_AUTH_LOGIN_URL = `${ASSISTANT_URL}/api/auth/login`;
export const ASSISTANT_AUTH_REGISTER_URL = `${ASSISTANT_URL}/api/auth/register`;
export const ASSISTANT_AUTH_RECOVER_URL = `${ASSISTANT_URL}/api/auth/recover`;
export const ASSISTANT_AUTH_RESET_PASSWORD_URL = `${ASSISTANT_URL}/api/auth/reset-password`;

// (Opcional) SSO
export const ASSISTANT_AUTH_GOOGLE_URL = `${ASSISTANT_URL}/api/auth/google`;
export const ASSISTANT_AUTH_MICROSOFT_URL = `${ASSISTANT_URL}/api/auth/microsoft`;

// 🔹 Chat endpoints
export const ASSISTANT_CHAT_HISTORY_URL = `${ASSISTANT_URL}/api/chat/history/s3`;
export const ASSISTANT_CHAT_SEND_URL = `${ASSISTANT_URL}/api/chat/send`;
export const ASSISTANT_REPORT_DOWNLOAD_URL = `${ASSISTANT_URL}/api/chat/report`;

// 🔹 Alumnos / CSV
export const ALUMNOS_API_URL = `${ASSISTANT_URL}/api/alumnos`;
export const CSV_UPLOAD_NOM_URL = `${ASSISTANT_URL}/api/auth/upload-nom`;

// 🔹 Cursos / CSV
export const CURSOS_API_URL = `${ASSISTANT_URL}/api/cursos`;
export const CSV_UPLOAD_CURSO_URL = `${ASSISTANT_URL}/api/auth/upload-curso`;
